import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function AdminMarques() {
  const [fournisseurs, setFournisseurs] = useState([]);
  const [marque, setMarque] = useState();
  const [newMarque, setNewMarque] = useState();
  const [entite_Id, setEntite_Id] = useState();
  const { marqueId } = useParams();
  const history = useHistory();

  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);

  const getFournisseur = () => axios.get(`${API_URL}/api/fournisseurs`);
  const getMarque = () =>
    axios.get(`${API_URL}/api/marques/${marqueId}`, {
      headers: { authorization: `Bearer ${token}` },
    });

  useEffect(() => {
    function getFournisseurs() {
      axios.all([getFournisseur(), getMarque()]).then((res) => {
        setFournisseurs(res[0].data);
        setEntite_Id(res[1].data.fournisseur_id);
        setMarque(res[1].data);
        setNewMarque(res[1].data.nom);
      });
    }

    getFournisseurs();
  }, []);

  const handleChange = (e) => {
    const { value } = e.target;
    setNewMarque(() => value);
  };

  function handleSubmit() {
    axios
      .put(
        `${API_URL}/api/marques/${marqueId}`,
        { newMarque, entite_Id },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        alert("Mise à jour effectuée !");
        history.push("/backoffice/home");
      })
      .catch((e) => {
        console.error(e);
        alert(`Erreur : ${e.message}`);
      });
  }

  function handleDelete() {
    axios
      .delete(`${API_URL}/api/marques/${marqueId}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        alert("Suppression effectuée !");
        history.push("/backoffice/home");
      })
      .catch((e) => {
        console.error(e);
        alert(`Erreur : ${e.message}`);
      });
  }

  return marque ? (
    <div>
      <h1>Modifier la marque {marque.nom}</h1>
      <input type="text" defaultValue={marque.nom} onChange={handleChange} />
      <select onChange={(e) => setEntite_Id(e.target.value)}>
        {fournisseurs.map((a) => (
          <option
            value={a.id}
            key={a.id}
            selected={a.id === marque.fournisseur_id ? "selected" : null}
          >
            {a.nom}{" "}
          </option>
        ))}
      </select>
      <button type="button" onClick={() => handleSubmit()}>
        Enregistrer
      </button>
      <button type="button" onClick={() => handleDelete()}>
        Supprimer cette marque
      </button>
    </div>
  ) : (
    "loading"
  );
}

export default AdminMarques;
